var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page != 'adgentWidget')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-lg-6 col-md-12 col-xl-5 col-xxl-5 hv-hs-container"},[_vm._t("content")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }